export default "<app-overlay></app-overlay>\n<router-outlet></router-outlet>"